import { usePermissions } from "@app/hooks/usePermissions";
import { Card, Container, Text } from "@mantine/core";
import type { ComponentType } from "react";
import React from "react";

interface PermissionGuardProps {
  component: ComponentType;
  requiredPermission: string;
  fallback?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  component: Component,
  requiredPermission,
  fallback
}) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(requiredPermission)) {
    return (
      fallback || (
        <Container size="sm" py="xl">
          <Card p="xl">
            <Text ta="center" size="lg" fw={500} mb="md">
              Access Denied
            </Text>
            <Text ta="center" c="dimmed">
              You don&apos;t have permission to access this page. Please contact your administrator if you believe this
              is an error.
            </Text>
          </Card>
        </Container>
      )
    );
  }

  return <Component />;
};
